export const config = {
    url: "https://trioteca.com",
    source: {
        cbre: 'c_b_r_e',
        vivendex: 'vivendex',
        anzizu: 'anzizu'
    }
}
